'use client';

import { Link } from '@/ui/Link';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { InformationCircleIcon as InformationCircleIconSolid } from '@heroicons/react/24/solid';

type Props = {
  assetId: string;
};

export const VideoButton = ({ assetId }: Props) => {
  return (
    <Link href={`/video/${assetId}`} className="group/{asset} w-11">
      <InformationCircleIconSolid className="hidden h-11 w-11 group-hover/{asset}:block" />
      <InformationCircleIcon className=" h-11 w-11 group-hover/{asset}:hidden" />
    </Link>
  );
};
